export default __webpack_public_path__ + "static/media/V250_RoHS.5646cd03.pdf";